







import { Settings } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class SettingsCredentialsAdd extends Vue {
  @Getter("settings/activeCacheSettings") settings!: Settings;

  buttonTitle = "Add New Credentials";

  isSaving = false;

  get buttonTitleAttr() {
    if (!this.settings.can_manage_credentials) {
      return "Your current plan does not allow this feature";
    } else {
      return "";
    }
  }

  addCredentials() {
    this.$ga.button(this.buttonTitle);

    this.buttonTitle = "Adding";
    this.isSaving = true;
    this.$store.dispatch("settings/addCredentials").then(() => {
      this.buttonTitle = "Added!";
      this.isSaving = false;
      setTimeout(() => {
        this.buttonTitle = "Add New Credentials";
      }, 1000);
    });
  }
}
